import {
    SimplePageContentWrapper,
    SimplePageLayout,
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {RecordsTable} from '../tables/RecordsTable';
import {usePaymentIntentsSelection} from '../hooks/usePaymentIntentsSelection';

/**
 * FNP-918: the payment-intents index page.
 *
 * Selection was `useState<PaymentIntent[]>` here and threaded into the table as
 * two props; it is now the Redux `payment-intents.selection` slice (§3, FNP-951).
 * The page still owns the hook instance and passes it down, because the DELETE
 * button lives in the page header — a sibling of the table, not a child — so
 * something above both has to hold the reference.
 *
 * ⚠️ Selection survives unmount now that it is in the store, so the batch
 * delete must clear it explicitly: handleClearSelection is passed as
 * onDeleteComplete. Without that, ids of cancelled payment intents stay
 * selected and the next confirm targets records that no longer exist — which on
 * a money-path module is a confirmation dialog stating a count the operator
 * cannot act on.
 */
export const IndexPage = () => {

    const selection = usePaymentIntentsSelection();

    return (
        <SimplePageLayout
            pageHeader={
                <IndexPageHeader
                    selectedIds={selection.selectedIds}
                    onDeleteComplete={selection.handleClearSelection}
                />
            }
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable selection={selection}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
